import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { TRANSLATIONS_EN } from "./locales/en/translation";

const RESOURCES = {
  en: {
    translation: TRANSLATIONS_EN
  }
};

const DETECTION_OPTIONS = {
  order: ['localStorage', 'navigator'],
  // caches: ['localStorage']
};

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    detection: DETECTION_OPTIONS,
    resources: RESOURCES
  });
i18n.changeLanguage(localStorage.getItem('i18nextLng'));

export default i18n;